module.exports = __webpack_public_path__ + "static/media/ultra-voucher.793686f2.jpeg";